import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";

import Navbar from "../../components/NavbarServices";

import fabrication from "../../images/videos/fabrication.mp4";
import borewell from "../../images/videos/borewell.mp4";
import soler from "../../images/videos/soler.mp4";
import House from "../../images/videos/RainWaterRechargeHow.mp4";

import S7 from "../../sections/S7_Message";
import S8 from "../../sections/S8_Footer";
import Heading from "../../components/Heading";

const Twolinks = styled.div`
  //   padding-top: 70px;
  padding-bottom: 70px;
`;
const Wrapper = styled.div`
  padding-top: 70px;
  padding-bottom: 80px;
`;

const index = () => {
  return (
    <div>
      <Navbar>Gallery</Navbar>
      <Container maxWidth="xl">
        <Wrapper>
          <Twolinks>
            <a style={{ textDecoration: "underline" }} href="#">
              videos
            </a>
            &nbsp;&nbsp;/&nbsp;&nbsp;
            <a style={{ textDecoration: "underline" }} href="/gallery/images">
              images{" "}
            </a>{" "}
          </Twolinks>
          <Grid container spacing={8}>
            <Grid item xs={12} md={6}>
              <Heading mb599="20px" fs="30px">
                Prefabricated Structure
              </Heading>
              <video width="100%" height="auto" controls>
                <source src={fabrication} type="video/mp4" />
              </video>
            </Grid>
            <Grid item xs={12} md={6}>
              <Heading mb599="20px" fs="30px">
                Let's Recharge with Rain Water
              </Heading>
              <video width="100%" height="auto" controls>
                <source src={borewell} type="video/mp4" />
              </video>
            </Grid>
            <Grid item xs={12} md={6}>
              <Heading mb599="20px" fs="30px">
                Structure Combination for Solar Energy
              </Heading>
              <video width="100%" height="auto" controls>
                <source src={soler} type="video/mp4" />
              </video>
            </Grid>
            <Grid item xs={12} md={6}>
              <Heading mb599="20px" fs="30px">
                Rain Water Recharge How
              </Heading>

              <video width="100%" height="auto" controls>
                <source src={House} type="video/mp4" />
              </video>
            </Grid>
          </Grid>
        </Wrapper>
      </Container>
      <S7 />
      <S8 />
    </div>
  );
};

export default index;
